// SUPER ADMIN DASHBOARD

import React from "react";
import SuperAdminDashLayout from "../masterLayout/SuperAdminDashLayout";
import SuperAdminCount from "../components/child/superAdminCount";
// import HourlyChart from "./child/HourlyChart";

const DashBoardSuperAdmin = () => {
  return (
    <SuperAdminDashLayout>
      {/* UnitCountOne */}
      <SuperAdminCount />
    </SuperAdminDashLayout>
  );
};

export default DashBoardSuperAdmin;
